import {NgModule} from "@angular/core";
import {SharedModule} from "../shared/shared.module";
import {FrameworkModule} from "../framework/framework.module";
import {TaxSingleSelectEditControlComponent} from "./tax/controls/tax-single-select-edit-control.component";
import {
    CompanyDetailsSingleSelectEditControlComponent
} from "./company-details/controls/company-details-single-select-edit-control.component";
import {
    CurrencyTypeSingleSelectEditControlComponent
} from "./currency/controls/currency-type-single-select-edit-control.component";
import {TaxMultiSelectEditControlComponent} from "./tax/controls/tax-multi-select-edit-control.component";
import {
    EmailSettingSingleSelectEditControlComponent
} from "./email-setting/controls/email-setting-single-select-edit-control.component";
import {StateMultiSelectSearchControlComponent} from "./state/controls/state-multi-select-search-control.component";
import {
    PeriodScheduleRuleEditComponent
} from "./period-schedule/period-schedule-rule-edit/period-schedule-rule-edit.component";
import {DateTimeSharedModule} from "../datetime/datetime.shared.module";
import {
    PeriodScheduleSingleSelectEditControlComponent
} from "./period-schedule/controls/period-schedule-single-select-edit-control.component";
import {
    PeriodScheduleMultiSelectEditControlComponent
} from "./period-schedule/controls/period-schedule-multi-select-edit-control.component";
import {PosSharedModule} from "../pos/pos.shared.module";
import {
    PeriodScheduleSingleSelectColumnComponent
} from "./period-schedule/controls/period-schedule-single-select-column.component";
import {CustomersSharedModule} from "../customers/customers.shared.module";

@NgModule({
    imports: [
        SharedModule,
        FrameworkModule,
        DateTimeSharedModule,
        PosSharedModule,
        CustomersSharedModule
    ],
    declarations: [
        TaxSingleSelectEditControlComponent,
        TaxMultiSelectEditControlComponent,
        CompanyDetailsSingleSelectEditControlComponent,
        CurrencyTypeSingleSelectEditControlComponent,
        EmailSettingSingleSelectEditControlComponent,
        PeriodScheduleRuleEditComponent,
        PeriodScheduleSingleSelectEditControlComponent,
        PeriodScheduleMultiSelectEditControlComponent,
        PeriodScheduleSingleSelectColumnComponent,
        StateMultiSelectSearchControlComponent
    ],
    exports: [
        TaxSingleSelectEditControlComponent,
        TaxMultiSelectEditControlComponent,
        CompanyDetailsSingleSelectEditControlComponent,
        CurrencyTypeSingleSelectEditControlComponent,
        EmailSettingSingleSelectEditControlComponent,
        PeriodScheduleRuleEditComponent,
        PeriodScheduleSingleSelectEditControlComponent,
        PeriodScheduleMultiSelectEditControlComponent,
        PeriodScheduleSingleSelectColumnComponent,
        StateMultiSelectSearchControlComponent
    ]
})
export class SystemSharedModule {
}
